import { render, staticRenderFns } from "./MaterialDialog.vue?vue&type=template&id=040df43c&scoped=true"
import script from "./MaterialDialog.vue?vue&type=script&lang=js"
export * from "./MaterialDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialDialog.vue?vue&type=style&index=0&id=040df43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.14_css-loader@6.11.0_webpack@5.99.8__ejs@3.1.10_loda_tabtodhn2upniikejzvtfgbz5m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040df43c",
  null
  
)

export default component.exports